// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 621) return "static/chunks/621.ed151a1866000b63.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"19":"1cfaf2a584553887","30":"9efd9cf736f5cda3"}[chunkId] + ".js";
};